// extracted by mini-css-extract-plugin
export default {"profile":"Navbar_profile__uMEp-","log":"Navbar_log__GNMPr"};